import {
  ArrowBottomIcon,
  ArrowRightIcon,
  AttachIcon,
  AttentionIcon,
  CheckIcon,
  CircleCheckIcon,
  CircleCloseIcon,
  CopyIcon,
  CrossCircleIcon,
  DarkCircleCloseIcon,
  DotIcon,
  ErrorIcon,
  ExclamationMarkCircleIcon,
  ExclamationMarkCircleOutlinedIcon,
  LocaleIcon,
  NonSuccessIcon,
  SuccessIcon,
  TrashIcon,
  ArrowLeftIcon,
  DownloadIcon,
} from '@themes/default/icons';

import {
  ArrowBottomIconVoltex,
  ArrowRightIconVoltex,
  AttachIconVoltex,
  AttentionIconVoltex,
  CheckIconVoltex,
  CircleCheckIconVoltex,
  CircleCloseIconVoltex,
  CopyIconVoltex,
  CrossCircleIconVoltex,
  DarkCircleCloseIconVoltex,
  DotIconVoltex,
  ErrorIconVoltex,
  ExclamationMarkCircleIconVoltex,
  ExclamationMarkCircleOutlinedIconVoltex,
  LocaleIconVoltex,
  NonSuccessIconVoltex,
  SuccessIconVoltex,
  TrashIconVoltex,
  AppLogoIconVoltex,
  ArrowLeftIconVoltex,
  DownloadIconVoltex,
} from '@themes/voltex/icons';

import {
  ArrowBottomIconRio,
  ArrowRightIconRio,
  AttachIconRio,
  AttentionIconRio,
  CheckIconRio,
  CircleCheckIconRio,
  CircleCloseIconRio,
  CopyIconRio,
  CrossCircleIconRio,
  DarkCircleCloseIconRio,
  DotIconRio,
  ErrorIconRio,
  ExclamationMarkCircleIconRio,
  ExclamationMarkCircleOutlinedIconRio,
  LocaleIconRio,
  NonSuccessIconRio,
  SuccessIconRio,
  TrashIconRio,
  ArrowLeftIconRio,
  AppLogoIconRio,
  DownloadIconRio,
} from '@themes/rio/icons';

export const ICON_SETS = {
  default: {
    'arrow-bottom': ArrowBottomIcon,
    'arrow-right': ArrowRightIcon,
    attach: AttachIcon,
    attention: AttentionIcon,
    check: CheckIcon,
    'circle-check': CircleCheckIcon,
    'circle-close': CircleCloseIcon,
    copy: CopyIcon,
    'cross-circle': CrossCircleIcon,
    'dark-circle-close': DarkCircleCloseIcon,
    dot: DotIcon,
    'error-red': ErrorIcon,
    'exclamation-mark-circle': ExclamationMarkCircleIcon,
    'exclamation-mark-circle-outlined': ExclamationMarkCircleOutlinedIcon,
    locale: LocaleIcon,
    'non-success': NonSuccessIcon,
    success: SuccessIcon,
    trash: TrashIcon,
    'app-logo': null,
    'arrow-left': ArrowLeftIcon,
    download: DownloadIcon,
  },
  voltex: {
    'arrow-bottom': ArrowBottomIconVoltex,
    'arrow-right': ArrowRightIconVoltex,
    attach: AttachIconVoltex,
    attention: AttentionIconVoltex,
    check: CheckIconVoltex,
    'circle-check': CircleCheckIconVoltex,
    'circle-close': CircleCloseIconVoltex,
    copy: CopyIconVoltex,
    'cross-circle': CrossCircleIconVoltex,
    'dark-circle-close': DarkCircleCloseIconVoltex,
    dot: DotIconVoltex,
    'error-red': ErrorIconVoltex,
    'exclamation-mark-circle': ExclamationMarkCircleIconVoltex,
    'exclamation-mark-circle-outlined': ExclamationMarkCircleOutlinedIconVoltex,
    locale: LocaleIconVoltex,
    'non-success': NonSuccessIconVoltex,
    success: SuccessIconVoltex,
    trash: TrashIconVoltex,
    'app-logo': AppLogoIconVoltex,
    'arrow-left': ArrowLeftIconVoltex,
    download: DownloadIconVoltex,
  },
  rio: {
    'arrow-bottom': ArrowBottomIconRio,
    'arrow-right': ArrowRightIconRio,
    attach: AttachIconRio,
    attention: AttentionIconRio,
    check: CheckIconRio,
    'circle-check': CircleCheckIconRio,
    'circle-close': CircleCloseIconRio,
    copy: CopyIconRio,
    'cross-circle': CrossCircleIconRio,
    'dark-circle-close': DarkCircleCloseIconRio,
    dot: DotIconRio,
    'error-red': ErrorIconRio,
    'exclamation-mark-circle': ExclamationMarkCircleIconRio,
    'exclamation-mark-circle-outlined': ExclamationMarkCircleOutlinedIconRio,
    locale: LocaleIconRio,
    'non-success': NonSuccessIconRio,
    success: SuccessIconRio,
    trash: TrashIconRio,
    'app-logo': AppLogoIconRio,
    'arrow-left': ArrowLeftIconRio,
    download: DownloadIconRio,
  },
} as const;
